import { toast, Slide } from 'react-toastify';

const createNotification = (
    message: string,
    type: 'info' | 'success' | 'warning' | 'error' | 'default',
    ignoreParent: boolean = false
) => {
    toast(message, {
        style:
            type == 'success'
                ? { backgroundColor: '#3ac47d' }
                : type == 'error'
                ? { backgroundColor: '#d92550' }
                : type == 'warning'
                ? { backgroundColor: '#e5b23e' }
                : {},
        transition: Slide,
        closeButton: true,
        closeOnClick: true,
        autoClose: 5000,
        position: 'top-right',
        type: type,
        icon: false,
    });
    if (!ignoreParent) {
        window.parent.postMessage(
            {
                type: 'notification',
                payload: {
                    message,
                    notificationType: type,
                },
            },
            '*'
        );
    }
};

export default createNotification;
